import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
import { getIn } from 'formik';
import FormHelperText from '@material-ui/core/FormHelperText';

import { CheckboxStyled, FormControlLabelStyled } from './Checkbox.styled';

const CheckboxField = ({
  field: { name, value },
  form,
  label,
  disabled,
  onChange,
  required,
  className,
  inputProps,
  asyncErrors,
  labelPlacement,
}) => {
  const [checked, setChecked] = useState(value || false);

  const handleShowError = () => {
    if (asyncErrors) {
      return asyncErrors;
    } else if (getIn(form?.errors, name) && getIn(form?.touched, name)) {
      return getIn(form?.errors, name);
    }
  };

  const toggleChecked = (event) => {
    form.setFieldValue(name, !checked);
    setChecked((prev) => !prev);
    if (onChange) onChange(event);
  };

  useEffect(() => {
    setChecked(value);
  }, [value]); // eslint-disable-line

  return (
    <FormControl component="fieldset" className={className}>
      <FormGroup aria-label="position" row>
        <FormControlLabelStyled
          value="start"
          label={label}
          style={{ fontSize: 10 }}
          control={
            <CheckboxStyled
              name={name}
              value={value}
              checked={checked}
              disabled={disabled}
              onChange={toggleChecked}
              inputProps={{
                'aria-label': name,
                ...inputProps,
              }}
            />
          }
          labelPlacement={labelPlacement}
        />
        {handleShowError() && required && (
          <FormHelperText
            style={{
              marginLeft: 16,
              marginTop: -10,
            }}
            error={true}
          >
            {handleShowError()}
          </FormHelperText>
        )}
      </FormGroup>
    </FormControl>
  );
};

CheckboxField.propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  field: PropTypes.shape({
    value: PropTypes.any,
    name: PropTypes.string,
    onChange: PropTypes.func,
  }),
  inputProps: PropTypes.object,
  checked: PropTypes.bool.isRequired,
  labelPlacement: PropTypes.oneOf(['top', 'start', 'bottom', 'end']),
};

CheckboxField.defaultProps = {
  form: {},
  field: {},
  inputProps: {},
  checked: false,
  disabled: false,
  labelPlacement: 'start',
  // className: {}
};

export default CheckboxField;
